angular.
module("dx.webapp.exam").
controller("DxExternalToolSettingsController", function externalToolSettingsController(
	$scope,
	dxLocalize,
	dxScrollIntoView,
	DxExternalToolSettings
) {
	"use strict";

	var self = this;

	self.onOffSettings = [
		{displayName: dxLocalize.get("On"), value: true},
		{displayName: dxLocalize.get("Off"), value: false},
	];

	self.editedExternalTool = null;
	self.editedExternalToolSettings = null;
	self.enabledExternalTools = {};

	function updateEnabledExternalTools() {
		self.enabledExternalTools = self.externalTools.reduce(function onReduce(res, tool) {
			res[tool.id] = self.exam.isExternalToolEnabled(tool.id);
			return res;
		}, {});
	}

	function clearEditedExternalTool() {
		self.editedExternalTool = null;
		self.editedExternalToolSettings = null;
	}

	function getExternalTool(toolId) {
		return self.externalTools.find(function findFn(tool) {
			return tool.id === toolId;
		});
	}

	self.$onInit = function onInitFn() {
		updateEnabledExternalTools();
	};

	self.$onChanges = function onChanges(changes) {
		if (changes.externalTools) {
			updateEnabledExternalTools();
		}
	};

	self.isExternalToolEditable = function isExternalToolEditable(tool) {
		return tool.landingPageIsEditable || tool.requiredPermissionsIsEditable;
	};

	// Get external tool settings by external tool ID
	self.getExternalToolSettings = function getExternalToolSettings(toolId) {
		var settings = self.exam.getExternalToolSettings(toolId);
		if (settings) {
			return angular.copy(settings);
		}

		var externalTool = getExternalTool(toolId);

		return DxExternalToolSettings.fromExternalTool(externalTool);
	};

	self.editExternalToolSettings = function editExternalToolSettings(toolId) {
		if (!self.exam.isExternalToolEnabled(toolId)) {
			return;
		}

		var externalTool = getExternalTool(toolId);

		if (!externalTool.landingPageIsEditable && !externalTool.requiredPermissionsIsEditable) {
			return; // if the external tool is not editable
		}

		self.editedExternalTool = externalTool;
		self.editedExternalToolSettings = self.getExternalToolSettings(toolId);

		var container = angular.element(".content-nailed");
		var element = angular.element("#externalToolSettings");
		var extraPaddingTop = 200;

		dxScrollIntoView(container, element, extraPaddingTop);
	};

	self.onSaveExternalToolSettings = function onSaveExternalToolSettings(settings) {
		self.exam.removeExternalToolSettings(settings.externalToolId);
		self.exam.addExternalToolSettings(settings);
		clearEditedExternalTool();
	};

	$scope.$watch("vm.enabledExternalTools", function watchFn(newVal, oldVal) {
		if (!newVal && !oldVal) {
			return;
		}

		self.externalTools.forEach(function forEachFn(tool) {
			// if the value hasn't changed
			if (newVal[tool.id] === oldVal[tool.id]) {
				return;
			}

			// if a new tool was enabled (switched to On)
			if (newVal[tool.id] && !self.exam.isExternalToolEnabled(tool.id)) {
				self.exam.addExternalToolSettings(DxExternalToolSettings.fromExternalTool(tool));
				// Open edit settings if landing page is empty and need to be set
				if (tool.landingPageUrl === "") {
					self.editExternalToolSettings(tool.id);
				} else {
					clearEditedExternalTool();
				}
			}

			// if a tool was disabled (switched to Off)
			if (!newVal[tool.id] && self.exam.isExternalToolEnabled(tool.id)) {
				self.exam.removeExternalToolSettings(tool.id);
				clearEditedExternalTool();
			}
		});
	}, true);

	$scope.$watch("vm.exam.externalToolSettings", function watchFn() {
		updateEnabledExternalTools();
	}, true);
});
